<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="row">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('wallets.label.add_day_bank_wallet')"></div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="wallet_title" v-text="$t('wallets.label.wallet_title')"></label>
                    <input class="form-control" id="wallet_title" name="wallet_title" v-model="form_data.wallet_title">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <kt-form-group>
                        <kt-form-label>
                            {{ $t('label.logo') }}
                        </kt-form-label>
                        <kt-form-label class="d-block btn btn-secondary btn-wide label-file" for="logo">
                            <kt-icon name="paperclip" type="fa"></kt-icon>
                            {{ $t('gateway.btn.click_me') }}
                        </kt-form-label>
                        <input
                                @change="processLogoFile"
                                accept="image/png"
                                class="custom-file-upload"
                                id="logo"
                                name="logo"
                                type="file"
                        />
                    </kt-form-group>
                </div>
                <div class="col-12 col-md-6 border p-4 m-2" v-show="gateways.length > 0">
                    <div v-text="$t('label.attach_to_gateways')" class="mb-4"></div>
                    <div class="form-group form-check" v-for="(gateway, index) in gateways" :key="index">
                        <input type="checkbox"
                               class="form-check-input px-2"
                               :id="`gateway${index}`"
                               @change="toggleGateway(gateway.id)"
                        >
                        <label class="form-check-label px-2 mx-4"
                               :for="`gateway${index}`">
                            {{ gateway.title }} ({{ gateway.id }})
                        </label>
                    </div>
                </div>
                <div class="col-12 mt-4">
                    <button class="btn btn-success" type="submit" v-text="form_meta_data.submit_btn_text"></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {gatewayService} from "@/common/api.service";

    export default {
        data() {
            return {
                gateways: [],
            };
        },
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
        methods: {
            toggleGateway(id) {
                let index = this.form_data.gateways.indexOf(id);

                if (index === -1) {
                    this.form_data.gateways.push(id);
                } else {
                    this.form_data.gateways.splice(index, 1);
                }

                console.log(this.form_data.gateways);
            },
            processLogoFile(event) {
                this.form_data.logo = event.target.files[0];

                if (this.validateSize(event.target)) {
                    if (this.validateFormat(event.target)) {
                        return;
                    }
                }

                this.form_data.logo = null;
            },
            validateSize(file) {
                let FileSize = file.files[0].size / 1024 / 1024; // in MB

                if (FileSize > 1) {
                    alert(i18n.t('authenticate.hint.fourth'));
                    $(file).val('');

                    return false;
                }

                return true;
            },
            validateFormat(file) {
                let jq_file = $(file);
                let file_name = jq_file.val();
                let extension = file_name.replace(/^.*\./, '');

                if (extension === file_name) {
                    extension = '';
                } else {
                    extension = extension.toLowerCase();
                }

                if (extension === 'png') {
                    return true;
                } else {
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
                    return false;
                }
            },
        },
        mounted() {
            gatewayService.get_payment_helper_shops().then(res => {
                this.gateways = res.data.data;
            });
        }
    }
</script>
